import { render, staticRenderFns } from "./PointOfContacts.html?vue&type=template&id=fb1deaf6&scoped=true&external"
import script from "./PointOfContacts.js?vue&type=script&lang=js&external"
export * from "./PointOfContacts.js?vue&type=script&lang=js&external"
import style0 from "./PointOfContacts.scss?vue&type=style&index=0&id=fb1deaf6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1deaf6",
  null
  
)

export default component.exports